// extracted by mini-css-extract-plugin
module.exports = {"carousel-img":"Carousel_carousel-img__3TYri","carousel-container":"Carousel_carousel-container__1WTqE","prev":"Carousel_prev__2p7cb","next":"Carousel_next__bjCGf"};